<template>
  <div class="announce-card-wrap">
    <div class="head-type">
      <div class="type-wrap"
           :style="{ background: backgroundColor }">
        {{ typeText }}
      </div>
    </div>
    <div class="announce-body-wrap">
      <div class="title single-omit">{{ instance.title }}</div>
      <div class="single-omit">转让方：{{ instance.licensor }}</div>
      <div class="single-omit">受让方：{{ instance.licensee }}</div>
      <div class="single-omit price-wrap">
        金额: <span class="price">{{ instance.price === -1 ? '面议' : '￥' + instance.price }}</span>
      </div>
      <div class="single-omit">运营日期: {{ instance.publishTime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    instance: Object,
  },
  data() {
    return {
      backgroundColor: '',
      typeText: '',
      texts: {
        0: '待转化',
        2: '质押',
        1: '许可',
        3: '转让',
      },
      colors: {
        0: '#89C997', // 转让
        1: '#6582FF', // 许可
        2: '#2279D2', // 质押
        3: '#FFC94D',
      },
    }
  },
  components: {},
  mounted() {
    this.initInstance()
  },
  methods: {
    initInstance() {
      const { operationType } = this.instance
      this.typeText = this.texts[operationType]
      this.backgroundColor = this.colors[operationType]
    },
  },
}
</script>
